<template>
  <div v-if="visibleNotifications.length" id="notification-banner" class="notification-banner">
    <b-alert v-for="notification in visibleNotifications"
             :key="notification.id"
             :id="'notification-' + notification.id"
             class="notification"
             variant="warning"
             :dismiss-label="$t('notification.dismiss')"
             show
             dismissible
             @dismissed="markRead(notification)">
      <b-icon-info-circle class="mr-2"/>
      <strong v-if="notification.title" class="notification-title">{{ notification.title }}</strong>
      <span class="notification-text">{{ notification.text }}</span>
    </b-alert>
  </div>
</template>

<script>
import service from "@/services/notification.service"
import {log} from "@emons/emons-vue"

export default {
  name: "NotificationBanner",
  data() {
    return {
      notifications: [],
      dismissedIds: []
    }
  },
  computed: {
    visibleNotifications: function () {
      return this.notifications.filter(notification => !this.dismissedIds.includes(notification.id))
    }
  },
  watch: {
    $route: function () {
      this.load()
    }
  },
  created() {
    this.load()
  },
  methods: {
    load: async function () {
      if (!this.$router.isLoggedIn()) {
        this.notifications = []
        return
      }
      try {
        const response = await service.findUnread()
        this.notifications = response?.data || []
      } catch (error) {
        log('error', 'Error querying notifications:', error)
      }
    },
    markRead: async function (notification) {
      this.dismissedIds.push(notification.id)
      try {
        await service.markRead(notification.id)
      } catch (error) {
        log('error', 'Error marking notification as read:', error)
      }
    }
  }
}
</script>

<style scoped>

.notification-banner {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1019;
  max-height: 50vh;
  overflow-y: auto;
}

.notification {
  margin-bottom: 0;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.notification-title {
  margin-right: 0.5rem;
}

.notification-text {
  white-space: pre-line;
}

</style>
